module.exports = __webpack_public_path__ + "media/images/clock-bda43451bf52d494a3dea97278c933df.svg";